import { useState, useEffect } from "react"
import { useWatch } from "react-hook-form"
import SelectField from "components/forms/fields/SelectField"

export default function SelectFieldDependent(props) {
    const [fieldOptions, setFieldOptions] = useState([])
    // TODO: possible to use the "disabled" property here for folding this into the standard SelectField ??
    const watchedFieldValue = useWatch({
        control: props.control,
        name: props.options.depends_on, // name of the field to watch
    })

    useEffect(() => {
        if (watchedFieldValue) {
            const generateOptions = async () => {
                const _options = await props.options.generate(watchedFieldValue)
                if (_options) {
                    setFieldOptions(_options)
                    // if the current value is not among the new options, then set the value to empty
                    if (!_options.map(opt => opt.value).includes(props.getValues(props.name))) {
                        props.setValue(props.name, "")
                    }
                }
            }
            generateOptions()
        }
    }, [watchedFieldValue])

    if (!fieldOptions.length && !props.options.showEmpty) return null

    return <SelectField {...props} options={fieldOptions} showEmpty={props.options.showEmpty} />
}
